module.exports = __webpack_public_path__ + "img/header-phone.9b83d6c3.png";